// extracted by mini-css-extract-plugin
export const container = "SubMenu-module--container--3xcYR";
export const is_closed = "SubMenu-module--is_closed--1togw";